/**
 * Estimates the reading time of a given text in minutes.
 * Calculation is based on an average reading speed of 200 words per minute.
 *
 * @param text - The text content to estimate reading time for
 * @returns The estimated reading time in minutes (rounded up to the nearest minute)
 * @example
 * const time = estimateReadingTime("Your article text here");
 * console.log(`Estimated reading time: ${time} minutes`);
 */
function estimateReadingTime(text: string): number {
  if (!text) return 0

  const wordsPerMinute = 200 // Average reading speed
  const wordCount = text.trim().split(/\s+/).filter(Boolean).length
  const readingTimeMinutes = Math.ceil(wordCount / wordsPerMinute)

  return readingTimeMinutes
}

function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

export { estimateReadingTime, formatFileSize }
